export default state => state.similarItems.loadingDataOnPageLoad;
